/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ThemeProvider } from 'styled-components';
export const UILibraryThemeProvider = (props) => React.createElement(ThemeProvider, Object.assign({}, props));
